module.exports = __webpack_public_path__ + "5c0d2e584e8dd164ecb36a41afd2b7ed.png";